import React from "react";

const ValueCard = (props) => {
  return (
    <div
      className="rounded-xl border border-primaryBorder bg-secondaryBg py-4 lg:py-8 px-3 lg:px-6 w-full flex flex-col gap-2 lg:gap-4"
      data-aos="fade-up"
      data-aos-duration={1000}
      data-aos-delay={400}
    >
      <h1 className="text-lg lg:text-xl font-bold text-center w-full bg-transparent">
        {props.title}
      </h1>
      <p className="text-center bg-transparent">{props.description}</p>
    </div>
  );
};

export default ValueCard;
